import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UnitReplacementModel } from 'src/app/pages/protected/components/component-unit-replacement-description/models/unit.replacement.result';
import { environment } from '@environment/environment';
import { map } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET, OPTIONS'
  })
};

@Injectable({
  providedIn: 'root'
})
export class UnitReplacementService {

  constructor(private http: HttpClient) { }

  getUnitReplacementDetails(serialNumber: string): Observable<UnitReplacementModel> {
    const serialNumberFormatted = serialNumber.trim();
    const baseUrl = environment.AzureFunctionUrl;
    const params = new HttpParams()
      .set('SerialNumber', serialNumberFormatted);

    const url = `${baseUrl}/api/GetUnitReplacementDetailsFunction`;

    return this.http.get<UnitReplacementModel>(url, { ...httpOptions, params }).pipe(
      map((res: UnitReplacementModel) => {
        return res;
      })
    );
  }
}
